import { render, staticRenderFns } from "./address-length.vue?vue&type=template&id=d95c0a04"
import script from "./address-length.vue?vue&type=script&lang=js"
export * from "./address-length.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports